import React from 'react';

import {Button} from '@albert-io/atomic';

import {useIsAnnotationModeActive} from 'client/components/PracticeView/Annotations/mode/useIsAnnotationModeActive';

import type {QuestionModelV3} from '@albert-io/models';
import {GuessModelV1} from '@albert-io/models';

import clearGuess from './clearGuess';
import loadGuess from './loadGuess';
import {isLegacyStore, getStoreByName} from 'client/components/QuestionTypes/V2/useQuestionStores';

interface Props {
  handleToggleSolution: (guess: GuessModelV1) => void;
  isViewingSolution: boolean;
  question: QuestionModelV3;
  questionStoreName: string;
}

export default function ToggleViewSolution({
  handleToggleSolution,
  isViewingSolution,
  question,
  questionStoreName
}: Props) {
  const store = question.getStore();
  const builtGuess = isLegacyStore(store) ? store.buildCorrectGuess(question) : null;
  const isAnnotationModeActive = useIsAnnotationModeActive();

  return (
    <Button
      disabled={isAnnotationModeActive}
      type='button'
      data-testid='practice-view__toggle-solution-btn'
      onClick={() => {
        if (isLegacyStore(store)) {
          if (isViewingSolution) {
            clearGuess(questionStoreName);
          } else {
            loadGuess(questionStoreName, builtGuess);
          }
          handleToggleSolution(builtGuess);
        } else {
          const zustandStore = getStoreByName(questionStoreName);
          if (zustandStore) {
            const zustandState = zustandStore.getState();
            if (isViewingSolution) {
              if (typeof zustandState.clearGuess === 'function') {
                zustandState.clearGuess();
              }
            } else {
              if (typeof zustandState.showSolution === 'function') {
                zustandState.showSolution();
              }
            }
          }
          handleToggleSolution(
            isViewingSolution
              ? null
              : new GuessModelV1({
                  content: question.getValidResponse(),
                  correct: true,
                  points_earned: question.getPoints(),
                  question_v3: question
                })
          );
        }
      }}
    >
      {isViewingSolution ? 'Hide' : 'Show'} solution
    </Button>
  );
}
